import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import 'stream-browserify'; // see https://github.com/ericgundrum/pouch-websocket-sync-example/commit/2a4437b013092cc7b2cd84cf1499172c84a963a3

import 'subworkers'; // polyfill for https://bugs.chromium.org/p/chromium/issues/detail?id=31666

import url from 'url';
import WorkerBasedMumbleConnector from './worker-client';
import BufferQueueNode from 'web-audio-buffer-queue';
import audioContext from 'audio-context';
import ko from 'knockout';
import _dompurify from 'dompurify';
import { PushToTalkVoiceHandler, initVoice } from './voice';

function ConnectDialog() {
  var self = this;
  self.address = ko.observable('');
  self.port = ko.observable('');
  self.username = ko.observable('');
  self.password = ko.observable('');
  self.channelName = ko.observable('');
  self.visible = ko.observable(true);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);

  self.connect = function () {
    self.hide();
    ui.connect(self.username(), self.address(), self.port(), self.password(), self.channelName());
  };
}

var GlobalBindings = function GlobalBindings(config) {
  var _this = this;

  _classCallCheck(this, GlobalBindings);

  this.config = config;
  this.connector = new WorkerBasedMumbleConnector();
  this.client = null;
  this.connectDialog = new ConnectDialog();

  this.setServerSyncCallback = function (callback) {
    _this.serverSyncCallback = callback;
  };

  this.setUserLoginCallback = function (callback) {
    _this.userLoginCallback = callback;
  };

  this.setNewChannelCallback = function (callback) {
    _this.newChannelCallback = callback;
  };

  this.setRemoveChannelCallback = function (callback) {
    _this.removeChannelCallback = callback;
  };

  this.setUpdateChannelCallback = function (callback) {
    _this.updateChannelCallback = callback;
  };

  this.setEnterChannelCallback = function (callback) {
    _this.enterChannelCallback = callback;
  };

  this.setJoinChannelCallback = function (callback) {
    _this.joinChannelCallback = callback;
  };

  this.setEntAnnounceCallback = function (callback) {
    _this.entAnnounceCallback = callback;
  };

  this.setChanAnnounceCallback = function (callback) {
    _this.chanAnnounceCallback = callback;
  };

  this.setBeKickedCallback = function (callback) {
    _this.beKickedCallback = callback;
  };

  this.setOfflineMessagesLoadedCallback = function (callback) {
    _this.onOfflineMessagesLoadedCallback = callback;
  }; //服务器强制停止讲话


  this.setStopTalkCallback = function (callback) {
    _this.onStopTalkCallback = callback;
  };

  this.setListenStateCallback = function (callback) {
    _this.listenStateCallback = callback;
  };

  this.setNewUserCallback = function (callback) {
    _this.newUserCallback = callback;
  };

  this.setRemoveUserCallback = function (callback) {
    _this.removeUserCallback = callback;
  };

  this.setUpdateUserCallback = function (callback) {
    _this.updateUserCallback = callback;
  };

  this.setApplyMicCallback = function (callback) {
    _this.applyMicCallback = callback;
  };

  this.setUserTalkingCallback = function (callback) {
    _this.userTalkingCallback = callback;
  };

  this.setUserCastingCallback = function (callback) {
    _this.userCastingCallback = callback;
  };

  this.setInstantMessageCallback = function (callback) {
    _this.instantMessageCallback = callback;
  };

  this.setStartMeetingCallback = function (callback) {
    _this.startMeetingCallback = callback;
  };

  this.setAnswerMeetingCallback = function (callback) {
    _this.answerMeetingCallback = callback;
  };

  this.setMeetingServerGotCallback = function (callback) {
    _this.meetingServerGotCallback = callback;
  };

  this.setPcmFrameCallback = function (callback) {
    _this.pcmFrameCallback = callback;
  };

  this.userLogin = function (host, port, username, password, entid, osName, appstore) {
    console.log('userLogin');

    _this.connect(username, host, port, '', password, '', entid, osName, appstore);
  };

  this.userLogout = function () {
    console.log('userLogout');

    _this.resetClient();
  };

  this.userEnterChannel = function (channelId) {
    console.log('userEnterChannel');

    _this.client.enterChannel(channelId);
  };

  this.userJoinChannel = function (payload) {
    console.log('userJoinChannel');

    _this.client.joinChannel(payload);
  };

  this.userCreateChannel = function (payload) {
    console.log('userCreateChannel');

    _this.client.createChannel(payload);
  };

  this.userListenChannel = function (channelId, listen) {
    console.log('userListenChannel');

    _this.client.listenChannel(channelId, listen);
  };

  this.userSendInstantMessage = function (payload) {
    console.log('userSendInstantMessage');

    _this.client.sendInstantMessage(payload);
  };

  this.userPushNotifyMessage = function (payload) {
    console.log('userPushNotifyMessage');

    _this.client.pushNotifyMessage(payload);
  };

  this.userSendEntAnnounceMessage = function (payload) {
    console.log('userSendEntAnnounceMessage');

    _this.client.sendEntAnnounceMessage(payload);
  };

  this.userSendChanAnnounceMessage = function (payload) {
    console.log('userSendChanAnnounceMessage');

    _this.client.sendChanAnnounceMessage(payload);
  };

  this.userNeedMoreRecordsMessage = function (payload) {
    console.log('userNeedMoreRecordsMessage');

    _this.client.sendNeedMoreRecordsMessage(payload);
  };

  this.userStartMeeting = function (payload) {
    console.log('userStartMeeting');

    _this.client.startMeeting(payload);
  };

  this.userAnswerMeeting = function (payload) {
    console.log('userAnswerMeeting');

    _this.client.answerMeeting(payload);
  };

  this.getAllChannels = function () {
    return _this.client._channels;
  };

  this.getAllUsers = function () {
    return _this.client._users;
  };

  this.getMyUserId = function () {
    return _this.client.self.userId;
  };

  this.getUserById = function (uid) {
    var users = _this.client._users;

    for (var _i = 0, _Object$values = Object.values(users); _i < _Object$values.length; _i++) {
      var user = _Object$values[_i];

      if (user.userId === uid) {
        return user;
      }
    } //如果没找到，默认返回undefined

  };

  this.getChannelById = function (cid) {
    var chans = _this.client._channels;

    for (var _i2 = 0, _Object$values2 = Object.values(chans); _i2 < _Object$values2.length; _i2++) {
      var chan = _Object$values2[_i2];

      if (chan.id === cid) {
        return chan;
      }
    } // 用下面方式得到的chan是undefined，todo
    //return this.client.getChannelById(cid);

  };

  this.userPttDown = function () {
    console.log('userPttDown');
    voiceHandler.pttDown();
  };

  this.userPttUp = function () {
    console.log('userPttUp');
    voiceHandler.pttUp();
  };

  this.connect = function (username, host, port) {
    var tokens = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var password = arguments.length > 4 ? arguments[4] : undefined;
    var channelName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
    var entid = arguments.length > 6 ? arguments[6] : undefined;
    var osName = arguments.length > 7 ? arguments[7] : undefined;
    var appstore = arguments.length > 8 ? arguments[8] : undefined;

    _this.resetClient(); // Note: This call needs to be delayed until the user has interacted with
    // the page in some way (which at this point they have), see: https://goo.gl/7K7WLu


    _this.connector.setSampleRate(audioContext().sampleRate);

    _this.connector.connect("wss://".concat(host, ":").concat(port), {
      username: username,
      password: password,
      ent_id: entid,
      osname: osName,
      appstore: appstore,
      tokens: tokens
    }).done(function (client) {
      console.log('logentry.connected');
      document.getElementById('loginUI').style.display = "none";
      document.getElementById("ic_miniprogram_logout").style.visibility = "visible";
      document.getElementById("ic_miniprogram_menu").style.visibility = "visible";
      document.getElementById('indexUI').style.display = "block";
      _this.client = client; // Prepare for connection errors

      client.on('error', function (err) {
        console.log('logentry.connection_error');

        _this.resetClient();
      });
      client.channels.forEach(function (channel) {
        return _this._newChannel(channel);
      }); // Register all users

      client.users.forEach(function (user) {
        return _this._newUser(user);
      });

      if (typeof _this.serverSyncCallback === "function") {
        console.log('serverSyncResult');

        _this.serverSyncCallback();
      }

      if (typeof _this.enterChannelCallback === "function") {
        console.log('serverSyncResult');

        _this.enterChannelCallback(client.self._channelId);
      }

      if (typeof _this.joinChannelCallback === "function") {
        console.log('serverSyncResult');

        _this.joinChannelCallback(client.self._channelId);
      } // Register future channels


      client.on('newChannel', function (channel) {
        return _this._newChannel(channel);
      }); // Register future users

      client.on('newUser', function (user) {
        return _this._newUser(user);
      }); // Log permission denied error messages

      client.on('denied', function (type) {
        ui.log.push({
          type: 'generic',
          value: 'Permission denied : ' + type
        });
      }); //zcx add,抢麦/放麦结果回调

      client.on('applyMicResult', function (apply, success) {
        console.log('applyMicResult');

        if (typeof _this.applyMicCallback === "function") {
          _this.applyMicCallback(apply, success);
        } //UserTalking在client里处理，这里无需处理


        if (apply) {
          if (success) {
            //抢麦成功
            voiceHandler.nowTalk();
          } else {//todo: notification
          }
        } else {}
      }); //zhangwei

      client.on('enterChannelResult', function (channelId) {
        console.log('enterChannelResult');

        if (typeof _this.enterChannelCallback === "function") {
          _this.enterChannelCallback(channelId);
        }
      });
      client.on('joinChannelResult', function (channelId) {
        console.log('joinChannelResult');

        if (typeof _this.joinChannelCallback === "function") {
          _this.joinChannelCallback(channelId);
        }
      });
      client.on('sendEntAnnounceResult', function (payload) {
        console.log('sendEntAnnounceResult');

        if (typeof _this.entAnnounceCallback === "function") {
          _this.entAnnounceCallback(payload);
        }
      });
      client.on('sendChanAnnounceResult', function (payload) {
        console.log('sendChanAnnounceResult');

        if (typeof _this.chanAnnounceCallback === "function") {
          _this.chanAnnounceCallback(payload);
        }
      }); //服务器强制停止讲话

      client.on('onStopTalk', function (payload) {
        if (typeof _this.onStopTalkCallback === "function") {
          _this.onStopTalkCallback(payload);
        }
      });
      client.on('onOfflineMessagesResult', function (payload) {
        console.log('onOfflineMessagesResult');

        if (typeof _this.onOfflineMessagesLoadedCallback === "function") {
          _this.onOfflineMessagesLoadedCallback(payload);
        }
      });
      client.on('listenStateResult', function (channelId, listen) {
        console.log('listenStateResult');

        if (typeof _this.listenStateCallback === "function") {
          _this.listenStateCallback(channelId, listen);
        }
      });
      client.on('userTalkingResult', function (userId, talking) {
        console.log('userTalkingResult  ' + userId);

        if (typeof _this.userTalkingCallback === "function") {
          _this.userTalkingCallback(userId, talking);
        }
      });
      client.on('userCastingResult', function (userId, nick, channelId, start, castUrl, videoUrl, time, duration, thumbnail) {
        console.log('userCastingResult');

        if (typeof _this.userCastingCallback === "function") {
          _this.userCastingCallback(userId, nick, channelId, start, castUrl, videoUrl, time, duration, thumbnail);
        }
      }); //收到实时消息

      client.on('instantMessageResult', function (from_id, target_id, message_type, content, time, thumbnail, size, duration, orig_name, chan_seq_id, from_nick) {
        if (typeof _this.instantMessageCallback === "function") {
          _this.instantMessageCallback(from_id, target_id, message_type, content, time, thumbnail, size, duration, orig_name, chan_seq_id, from_nick);
        }
      }); //收到meeting呼叫

      client.on('startMeetingReceived', function (from_id, from_nick, meeting_id) {
        if (typeof _this.startMeetingCallback === "function") {
          _this.startMeetingCallback(from_id, from_nick, meeting_id);
        }
      }); //自己meeting呼叫，收到别人应答

      client.on('answerMeetingReceived', function (user_id, meeting_id, callee_state) {
        if (typeof _this.answerMeetingCallback === "function") {
          _this.answerMeetingCallback(user_id, meeting_id, callee_state);
        }
      }); //服务器下发了通话服务器地址
      //TODO：2025.6.30 这里走不到，原因待查

      client.on('meetingServerGot', function (addr) {
        if (typeof _this.meetingServerGotCallback === "function") {
          _this.meetingServerGotCallback(addr);
        }
      });
      client.on('pcmAudioResult', function (pcmAudio) {
        console.log('pcmAudioResult');

        if (typeof _this.pcmFrameCallback === "function") {
          _this.pcmFrameCallback(pcmAudio);
        }
      }); // Startup audio input processing

      _this._updateVoiceHandler();
    }, function (err) {
      document.getElementById('loginState').innerHTML = "登录失败，请重新尝试";
      document.getElementById("messages").style.visibility = "visible";

      if (err.$type && err.$type.name === 'Reject') {
        console.log('loginResult');

        if (typeof _this.userLoginCallback === "function") {
          _this.userLoginCallback(err.type, err.reason);
        }
      } else {
        console.log('logentry.connection_error');
      }
    });
  };

  this._newUser = function (user) {
    var simpleProperties = {
      userId: 'uid',
      username: 'name'
    };

    if (typeof _this.newUserCallback === "function") {
      console.log('new user');

      _this.newUserCallback(user);
    }

    var ui = user.__ui = {
      model: user,
      talking: ko.observable('off'),
      channel: ko.observable()
    };
    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(user[key[0]]);
    });

    if (user.channel) {
      ui.channel(user.channel.__ui);
      ui.channel().users.push(ui);
      ui.channel().users.sort(compareUsers);
    }

    user.on('update', function (actor, properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });

      if (properties.channel !== undefined) {
        if (ui.channel()) {
          ui.channel().users.remove(ui);
        }

        ui.channel(properties.channel.__ui);
        ui.channel().users.push(ui);
        ui.channel().users.sort(compareUsers);

        if (typeof _this.updateUserCallback === "function") {
          console.log('update user');

          _this.updateUserCallback();
        }
      }
    }).on('remove', function () {
      if (ui.channel()) {
        ui.channel().users.remove(ui);

        if (typeof _this.removeUserCallback === "function") {
          _this.removeUserCallback();
        }
      }
    }).on('voice', function (stream) {
      //console.log(`User ${user.username} started takling`)
      var userNode = new BufferQueueNode({
        audioContext: audioContext()
      });
      userNode.connect(audioContext().destination);
      stream.on('data', function (data) {
        ui.talking('on');
        userNode.write(data.buffer);
      }).on('end', function () {
        console.log("User ".concat(user.username, " stopped takling"));
        ui.talking('off');
        userNode.end();
      });
    });
  };

  this._newChannel = function (channel) {
    var simpleProperties = {
      id: 'id',
      name: 'name',
      member_count: 'member_count',
      max_seq_id: 'max_seq_id',
      creator_id: 'creator_id',
      temporary: 'temporary',
      is_listen: 'is_listen'
    };

    if (typeof _this.newChannelCallback === "function") {
      console.log('new channel');

      _this.newChannelCallback(channel);
    }

    var ui = channel.__ui = {
      model: channel,
      channels: ko.observableArray(),
      users: ko.observableArray()
    };

    ui.userCount = function () {
      return ui.channels().reduce(function (acc, c) {
        return acc + c.userCount();
      }, ui.users().length);
    };

    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(channel[key[0]]);
    });
    channel.on('update', function (properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });

      if (typeof _this.updateChannelCallback === "function") {
        console.log('update channel');

        _this.updateChannelCallback();
      }
    }).on('remove', function () {
      if (typeof _this.removeChannelCallback === "function") {
        console.log('remove channel');

        _this.removeChannelCallback();
      }
    });
  };

  this.resetClient = function () {
    if (_this.client) {
      _this.client.disconnect();
    }

    _this.client = null;
  };

  this._updateVoiceHandler = function () {
    if (!_this.client) {
      return;
    }

    if (voiceHandler) {
      voiceHandler.end();
      voiceHandler = null;
    }

    voiceHandler = new PushToTalkVoiceHandler(_this, _this.client, _this.settings);
  };
};

var ui = new GlobalBindings(window.mumbleWebConfig); // Used only for debugging

window.totalkAPI = ui;

function initializeUI() {
  var queryParams = url.parse(document.location.href, true).query;
  queryParams = Object.assign({}, window.mumbleWebConfig.defaults, queryParams);

  if (queryParams.address) {
    ui.connectDialog.address(queryParams.address);
  }

  if (queryParams.port) {
    ui.connectDialog.port(queryParams.port);
  }

  if (queryParams.username) {
    ui.connectDialog.username(queryParams.username);
  }

  if (queryParams.password) {
    ui.connectDialog.password(queryParams.password);
  }

  if (queryParams.channelName) {
    ui.connectDialog.channelName(queryParams.channelName);
  }

  ko.applyBindings(ui);
}

function compareChannels(c1, c2) {
  return c1.name() === c2.name() ? 0 : c1.name() < c2.name() ? -1 : 1;
}

function compareUsers(u1, u2) {
  return u1.name() === u2.name() ? 0 : u1.name() < u2.name() ? -1 : 1;
}

var voiceHandler;

function main() {
  return _main.apply(this, arguments);
}

function _main() {
  _main = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            initializeUI();
            initVoice(function (data) {
              if (!ui.client) {
                if (voiceHandler) {
                  voiceHandler.end();
                }

                voiceHandler = null;
              } else if (voiceHandler) {
                //登录后，无论是否开始讲话，这里都一直执行
                voiceHandler.write(data);
              }
            }, function (err) {
              console.log('logentry.mic_init_error');
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _main.apply(this, arguments);
}

window.onload = main;
console.log('window.onload');